export default "__VITE_ASSET__F_4anRol__"